import classnames from 'classnames';

const className = classnames(
  'flex',
  'flex-1',
  'flex-col',
  'justify-center',
  'items-center',
  'uppercase',
  'text-card-subtitle-color'
);

interface Props {
  children: string;
}

const Attention = ({ children }: Props) => (
  <div className={className}>
    <h5 className="text-xl">{children}</h5>
  </div>
);

export default Attention;
